export type ClientEvent =
	| "auth.sign_in.error"
	| "auth.sign_out.error"
	| "auth.sign_in.success"
	| "auth.sign_out.success";

export class AuthEvent extends Event {
	constructor(
		type: ClientEvent,
		public payload: any,
	) {
		super(type);
	}
}
